import { v4 } from 'uuid';

const idPrefix = v4();

export const TRIAL_ONBOARDING_ARROW_START_ELEMENT_ID = `scan-${idPrefix}`;
export const TRIAL_ONBOARDING_ARROW_END_ELEMENT_ID = `qrCode-${idPrefix}`;
